import React, { useState, useContext } from 'react';
import { ApiService } from '../Axios/ApiService';
import { FileUploadContext } from '../Providers/FileUploadProvider/FileUploadProvider';
import {VerspreidenContext} from "../Providers/VerspreidenProvider";

const useAddProductToCart = (
    sku,
    productComment,
    productName,
    productCategory,
    taal
) => {
    const { files, extraOption } = useContext(FileUploadContext);
    const {
        verspreidDatums
    } = useContext(VerspreidenContext);

    const [submittingCart, setSubmittingCart] = useState({
        loading: false,
        error: false,
    });

    const onAddProductToCart = async (
        deliveryId,
        variationId,
        quantity,
        productId,
        price
    ) => {
        if (files && files.length > 0) {
            var fileRefs = files.map(file => ({
                value: file.value,
            }));
        }
        if(verspreidDatums) {
            var verspreidDatumRef = verspreidDatums;
        }

        const formData = {
            variation_id: variationId,
            quantity,
            delivery: deliveryId,
            product_id: productId,
            // fields,
            sku,
            extra_file_option: extraOption,
            uploadfiles: fileRefs || null,
            verspreidatum: verspreidDatumRef || null,
            comment: productComment,
        };
        setSubmittingCart({
            loading: true,
        });
        try {
            const res = await ApiService.post('/addtocart', formData);

            var items = [];
            items.push({
                item_id: productId,
                item_name: productName,
                item_category: productCategory,
                item_brand: '24',
                item_variant: sku,
                price: price,
                quantity: quantity
            })

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'add_to_cart',
                ecommerce: {
                    items: items
                }
            })

            window.location.replace('/winkelwagen');
        } catch (e) {
            setSubmittingCart({
                error: true,
            });
            console.error(e);
            throw e;
        }
    };

    return { onAddProductToCart, submittingCart };
};

export default useAddProductToCart;
